import React from 'react';
import { Select, SelectProps } from 'antd';
import { noop } from 'lodash';
import { useQuery } from 'react-query';
import {
  getVendorListByBrokerid,
  MgBrokerVendor,
} from 'services/parametersService';

export type ParListSelectVendorProps = SelectProps<any> & {
  value?: any;
  onChange?: (Vendor: MgBrokerVendor) => void;
  onSelected?: (Vendor: MgBrokerVendor) => void;
  disabled?: boolean;
  allowClear?: boolean;
  style?: any;
  tpidbroker: number;
  mgid: number;
};

const ParListSelectVendor = ({
  value,
  tpidbroker,
  mgid,
  onChange = noop,
  onSelected,
  ...otherProps
}: ParListSelectVendorProps) => {
  const { data: Vendor, isLoading } = useQuery(
    ['getVendorListByBrokerid', { tpidbroker }],
    () =>
      getVendorListByBrokerid({ mgid, tpidbroker }).then((res) => {
        return res.list || [];
      }),
    { enabled: !!tpidbroker, refetchOnMount: true }
  );

  const handleChange: SelectProps<any>['onChange'] = (value, option) => {
    onChange(value);
    if (onSelected) {
      if (value.vendorid)
        onSelected(Vendor?.find((item) => item.vendorid === value.vendorid)!);
      else onSelected(Vendor?.find((item) => item.vendorid === value)!);
    }
  };

  return (
    <Select
      onChange={handleChange}
      {...otherProps}
      loading={isLoading}
      allowClear
      value={!value?.vendorid ? value : value.vendorid}
    >
      {Vendor?.map((vndr) => (
        <Select.Option value={vndr.vendorid} key={vndr.vendorid}>
          {vndr.vendorname}
        </Select.Option>
      ))}
    </Select>
  );
};

export default ParListSelectVendor;
